import styled from 'foundations-theming/utils';
import { MEDIA_SIZES } from '../hooks/useElementSize';
export const GAP = 16;
export const GAP_TOKEN = '400';
export const ROW_GAP = 8;
export const ROW_GAP_TOKEN = '200';
export const INPUT_WIDTHS = {
  [MEDIA_SIZES.md]: 250,
  [MEDIA_SIZES.lg]: 400
};
export const LABEL_WIDTHS = {
  [MEDIA_SIZES.md]: INPUT_WIDTHS[MEDIA_SIZES.md],
  [MEDIA_SIZES.lg]: INPUT_WIDTHS[MEDIA_SIZES.lg]
};
export const INPUT_WIDTHS_FOR_TWO_INPUTS_WITH_BULLET_POINT = {
  [MEDIA_SIZES.md]: 240,
  [MEDIA_SIZES.lg]: 390
};
export const INPUT_WIDTHS_FOR_THREE_INPUTS_WITH_BULLET_POINT = {
  [MEDIA_SIZES.md]: 180,
  [MEDIA_SIZES.lg]: 255
};
export const INPUT_WIDTHS_EDITOR_CONDITION = {
  [MEDIA_SIZES.md]: 200,
  [MEDIA_SIZES.lg]: 275
};
export const INPUT_WIDTHS_CONDITION_REFINEMENT = {
  [MEDIA_SIZES.md]: 220,
  [MEDIA_SIZES.lg]: 285
};
export const INPUT_WIDTHS_LOGIC_GROUP_REFINEMENT = {
  [MEDIA_SIZES.md]: 220,
  [MEDIA_SIZES.lg]: 285
};
export const INPUT_WIDTHS_PAGE_VIEW_PARAMETERS = {
  [MEDIA_SIZES.md]: 220,
  [MEDIA_SIZES.lg]: 285
};
export const FlexDateInputWithTimezoneWrapper = styled.div.withConfig({
  displayName: "inlineLayout__FlexDateInputWithTimezoneWrapper",
  componentId: "sc-1n5w7xn-0"
})(["display:flex;flex-wrap:nowrap;"]);